import httpClient from '../httpClient';

const listingPromotions = 'listing-promotions';

const change = (listingId, plan) => {
  return httpClient.post(`${listingPromotions}/${listingId}/change`, { plan });
};

const getDetails = listingId => {
  return httpClient.get(`${listingPromotions}/${listingId}/details`);
};

const renew = listingId => {
  return httpClient.post(`${listingPromotions}/${listingId}/renew`);
};

const subscribe = (listingId, plan) => {
  return httpClient.post(`${listingPromotions}/${listingId}/subscribe`, { plan });
};

const subscribeBulk = (listingsIds, plan) => {
  return httpClient.post(`${listingPromotions}/subscribe-bulk`, { listingsIds, plan });
};

const unsubscribe = listingId => {
  return httpClient.post(`${listingPromotions}/${listingId}/unsubscribe`);
};

const getPrices = () => {
  return httpClient.get(`${listingPromotions}/plans`);
};

export default {
  change,
  getDetails,
  getPrices,
  renew,
  subscribe,
  subscribeBulk,
  unsubscribe,
};
